import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner, Alert } from '../../services/notiflix.service';
import { useState, useEffect } from 'react';
import UserAgreementService from '../../services/user-agreement.service';
import Pagination from '../../components/common/Pagination';
import { useSelector } from 'react-redux';
import { OpenNewTabIcon } from '../../components/common/IconProvider';
import { formatDate, formatWithEllipsis } from '../../utils/Helper';
import ImageLoader from '../../components/common/ImageLoader';
import { useTranslation } from 'react-i18next';
const ProjectAgreement = () => {
  const { user: _authUser } = useSelector((state) => state.auth);
  const [isUserAgreementLists, setUserAgreementList] = useState([]);
  const [filterData, setfilterData] = useState({
    perPage: 5,
    page: 1,
    user_id: _authUser.userId,
    type: 'project',
  });
  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });
  useEffect(() => {
    userAgreementList();
  }, []);
  const userAgreementList = async () => {
    try {
      Spinner.show();
      let _projectListRes = await UserAgreementService.list(
        filterData.perPage,
        filterData.page,
        filterData.user_id,
        filterData.type,
      );
      if (_projectListRes.status === 'failure') {
        Spinner.hide();
        Alert.error(_projectListRes.message);
        return false;
      }
      Spinner.hide();
      setUserAgreementList(_projectListRes.data.records);

      setPagination({
        totalPages: _projectListRes.data.pagination.totalPages,
        currentPage: _projectListRes.data.pagination.page,
      });
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };
  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });

    setfilterData({
      ...filterData,
      page: current,
    });
  };

  const { t } = useTranslation(['projectAgreement', 'common']);
  return (
    <>
      <div className="md:pb-5 md:pl-5">
        <div className=" text-center my-24">
          <h2 className="dark:text-white">{t('signed_agreements')}</h2>
          <p className="mt-2 dark:text-white">
            {t('check_signed_agreements_details')}
          </p>
        </div>
        <div className="bg-[#F3F3F3] md:dark:bg-slate-800 md:dark:text-slate-200 p-4 rounded-md">
          <div className="relative overflow-x-auto  sm:rounded-lg">
            <table className="tableradus w-full text-sm text-left  bg-[#F3F3F3] dark:bg-slate-800 dark:text-slate-200 border-separate border-spacing-y-3 shadow-none">
              <thead className="text-xs uppercase ">
                <tr>
                  <th scope="col" className="common-padding-xy">
                    {t('common:sr_no')}
                  </th>
                  <th scope="col" className="common-padding-xy">
                    Project
                  </th>
                  <th scope="col" className="common-padding-xy">
                    {t('common:date')}
                  </th>
                  <th scope="col" className="common-padding-xy">
                    {t('common:agreement')}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-[#F3F3F3] dark:bg-slate-800 dark:text-slate-200">
                {isUserAgreementLists &&
                  isUserAgreementLists?.length > 0 &&
                  isUserAgreementLists.map((list, index) => (
                    <tr
                      key={index}
                      className="bg-white border-b dark:bg-slate-900 dark:border-slate-700 mb-3"
                    >
                      <th scope="row" className="common-padding-xy text-style">
                        {index + 1}
                      </th>

                      <th scope="row" className="common-padding-xy text-style">
                        {list?.projectDetails?.name || 'NA'}
                      </th>

                      <th scope="row" className="common-padding-xy text-style">
                        {formatDate(list?.created_at, 'Do MMM YY')}
                      </th>
                      <th scope="row" className="common-padding-xy text-style">
                        {list?.agreement_url ? (
                          <a
                            href={
                              list?.agreement_url
                                ? list?.agreement_url
                                : '_self'
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center text-brandBlue dark:text-white underline"
                          >
                            {formatWithEllipsis(list?.agreement_url, 43)}
                            <OpenNewTabIcon />
                          </a>
                        ) : (
                          'NA'
                        )}
                      </th>
                    </tr>
                  ))}
              </tbody>
            </table>
            {isUserAgreementLists && isUserAgreementLists?.length === 0 && (
              <div className="mb-6">
                <div className="mx-auto text-center">
                  <ImageLoader
                    src="/img/performedanytransaction.png"
                    className="inline-block mb-2"
                    alt=""
                  />
                </div>
                <div className="text-center text-2xl font-semibold text-brandBlue dark:text-slate-200 mb-3">
                  {t('no_signed_agreements')}
                </div>
                <div className="text-center">
                  <Link to="/assets">
                    <button className="bg-[#A7D760] text-[#0B243F] text-md font-semibold rounded-md px-5 leading-normal py-2 flex-inline flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all mt-12">
                      {t('common:explore_projects')}
                    </button>
                  </Link>
                </div>
              </div>
            )}
            {isUserAgreementLists && isUserAgreementLists?.length > 0 && (
              <Pagination
                total={isPagination.totalPages}
                current={isPagination.currentPage}
                pagination={(crPage) => handlePagination(crPage)}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectAgreement;
